import {
  Component,
  Injectable,
  OnInit,
  Output,
  EventEmitter,
  Input,
  TemplateRef,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { CampaignService } from '../../../../../../common/services/Campaign.service';
import { SearchService } from '../../../../../../common/services/Search.service';
import { FieldService } from '../../../../../../common/services/Field.service';
import { OrganizeService } from '../../../../../../common/services/Organize.service';
import { UserService } from '../../../../../../common/services/User.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Rx';
import { EvsAddressService } from '../../../../../../common/services/EvsAddress.service';
import { DetailCampaignConst, getStatusCodeSipChunk, StatusSipChunk } from '../detail.const';
import { SocketService } from '../../../../../../common/services/Socket.service';
import { TicketService } from '../../../../../../common/services/Ticket.service';
import { ContactService } from '../../../../../../common/services/Contact.service';
import { GroupService } from '../../../../../../common/services/Group.service';
import { isEmail } from '../../../../../../common/utils/validate';
import {
  FormFieldType,
  ModalType,
  TypeModal,
} from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { importResponseTemplate } from '../../../../../../common/conversations/import.response';
import { CommonService } from '../../../../../../common/services/Common.service';
import { SharedUserService } from '../../../../../../common/share-data/user.service';
import { CommonSettingsService } from '../../../../../../common/share-data/common.setting.service';

@Component({
  selector: 'app-campaign-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['../detail.css'],
})
export class ContactsComponent extends BaseListComponent {
  @ViewChild('filterTemplate') filterTemplate: ElementRef;
  @ViewChild('templateCallOut') templateCallOut: ElementRef;
  @ViewChild('templateFilter') templateFilter: ElementRef;

  @Input() campaign_id: any;
  @Input() campaign: any;
  public show: any = 'list';
  public step = 1;
  public importTab = 'import-customer';
  public importType = 'filter';
  public typeFilter = 'user';
  public saveFilterTicket: any = {};
  public importRes: any = '';
  public importModel: any = {};
  public listFilterUser: any[] = [];
  public listFilterTicket: any[] = [];
  public exportFields: any[] = [];
  public organizes: any[] = [];
  public select2Organizes: any[] = [];
  public cities: any[] = [];
  public select2Cities: any[] = [];
  public allUser: any[] = [];
  public allGroup: any[] = [];
  public allAgent: any[] = [];
  public listStatus: any[] = [];
  public allStatus: any[] = [];
  public listCampaigns: any[] = [];
  public allCampaigns: any[] = [];
  public ticketFields: any[] = [];
  private default_timeout = 5000;
  public allGroupEndUser: any[] = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private campaignService: CampaignService,
    private searchService: SearchService,
    private fieldService: FieldService,
    private organizeService: OrganizeService,
    private userService: UserService,
    private addressService: EvsAddressService,
    private socketService: SocketService,
    private ticketService: TicketService,
    private contactService: ContactService,
    private commonService: CommonService,
    private sharedUserService: SharedUserService,
    private sharedCommonSettings: CommonSettingsService,
    private groupService: GroupService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {
    this.is_loading = true;
    await this.loadUser();
    await this.loadCities();
    await this.loadOrganizes();
    await this.loadGroups();
    await this.loadStatus();
    await this.loadCampaigns();
    await this.loadGroupEndUser();
    await this.loadTicketFields();
    Observable.forkJoin([
      this.searchService.listFilter({ type: 'user' }),
      this.searchService.listFilter({ type: 'ticket' }),
      this.campaignService.allAgentInQueue(this.campaign_id),
    ]).subscribe(async data => {
      this.loadFilters(data[0], 'user');
      this.loadFilters(data[1], 'ticket');
      this.loadAllAgentInQueue(data[2]);
      // @ts-ignore
      const { contact_campaign_table_columns } = (await this.sharedCommonSettings.getUserConfig()) || {};
      const displayColumns = DetailCampaignConst.displayColumn(
        this.campaign.campaign_type,
        this.ticketFields,
        this.campaign.dial_mode
      );
      if (contact_campaign_table_columns) {
        const saveDisplayColumns = JSON.parse(contact_campaign_table_columns);
        console.log(saveDisplayColumns);
        this.displayColumns = displayColumns.map(d => {
          try {
            const sD = saveDisplayColumns.find(sd => d.field === sd.field);
            if (sD) {
              d.display = sD.display;
            }
            return d;
          } catch (e) {
            return d;
          }
        });
      } else {
        this.displayColumns = displayColumns;
        await this.commonService
          .settingUserConfig({
            user_id: this.user._id,
            contact_campaign_table_columns: JSON.stringify(this.displayColumns),
          })
          .toPromise();
      }
      this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
      await this.loadData();
    });
  }

  async loadGroupEndUser() {
    const res = await this.sharedUserService.getCustomerGroups();
    const groupList = [];
    res.forEach((c: any) => {
      groupList.push({
        text: c.name,
        id: c.id.toString(),
      });
    });
    this.allGroupEndUser = groupList;
  }

  async loadUser() {
    const res = await this.sharedUserService.getAllUsers();
    const agentList = [];
    res.forEach((c: any) => {
      agentList.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allUser = agentList;
  }

  async loadCities() {
    const res = await this.sharedCommonSettings.getAllCities();
    const cityList = [];
    res.forEach((c: any) => {
      cityList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.select2Cities = cityList;
  }

  async loadOrganizes() {
    const res = await this.sharedCommonSettings.getAllOrganize();
    const organizeList = [];
    res.forEach((c: any) => {
      organizeList.push({
        text: c.name,
        id: c.organize_id,
      });
    });
    this.select2Organizes = organizeList;
  }

  loadFilters(res, type) {
    if (res.status == 200 && !res.error) {
      const filters = [{ id: '', text: 'Chọn' }];
      res.data.data.forEach(e => {
        filters.push({
          id: e._id,
          text: e.name,
        });
      });
      this.listFilterUser = filters;
    }
  }

  async loadTicketFields() {
    const res = await this.sharedCommonSettings.getAllTicketFields();
    res.forEach(e => {
      this.ticketFields.push({
        key: e.key,
        title: e.title,
        type: e.type,
      });
    });
  }

  loadAllAgentInQueue(res) {
    if (!res.error && res.status == 200) {
      const agentList = [];
      res.data.data.forEach((c: any) => {
        agentList.push({
          text: c.name,
          id: c._id,
          group_id: c.group_id,
        });
      });
      this.allAgent = agentList;
    }
  }

  async loadGroups() {
    const res = await this.sharedUserService.getUserGroups();
    const groupList = [];
    res.forEach((c: any) => {
      groupList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allGroup = groupList;
  }

  async loadStatus() {
    const res = await this.sharedCommonSettings.getAllStatus();
    const statusList = [];
    res.forEach((c: any) => {
      if (['new', 'doing', 'reopen'].includes(c.code)) {
        statusList.push({
          text: c.name,
          id: c.id,
        });
      }
    });
    this.allStatus = statusList;
  }
  async loadCampaigns() {
    const res = await this.sharedCommonSettings.getAllCampaign();
    const campaign_list = [];
    res.forEach((c: any) => {
      campaign_list.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allCampaigns = campaign_list;
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.campaignService.listContact(this.campaign_id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.data = res.data.list.map(res => {
            res.display_status = getStatusCodeSipChunk(res.status);
            res.display_name = DetailCampaignConst.displayNameColumn(res, this.user);
            res.display_phone = DetailCampaignConst.displayPhoneColumn(res, this.user);
            res.display_email = DetailCampaignConst.displayEmailColumn(res);
            res.display_organize = DetailCampaignConst.displayOrganizeColumn(res, this.organizes);
            res.display_city = DetailCampaignConst.displayCityColumn(res, this.cities);
            res.display_created_at = DetailCampaignConst.displayTimeColumns(res.created_at);
            res.display_ticket = DetailCampaignConst.displayTicketColumn(res);
            res.display_assignee = DetailCampaignConst.displayTicketAssigneeColumn(res.ticket, this.allUser);
            res.display_dob = DetailCampaignConst.displayDob(res);
            res.display_cpName = DetailCampaignConst.displayCpNameColumn(res);
            res.display_firstActionIvr = DetailCampaignConst.displayFirstActionIvrColumn(res);
            res.display_dtmf = DetailCampaignConst.displayDtmfColumn(res);

            this.ticketFields.forEach(t => {
              res['display_' + t.key] = DetailCampaignConst.displayFieldColumn(res.ticket, t);
            });
            res._customClasses = [
              {
                key: 'display_status',
                classes: res.status === StatusSipChunk.SUCCESS ? 'text-white bg-success' : '',
              },
              {
                key: 'retry_total',
                classes: res.retry_total == '0' ? '' : 'text-primary',
              },
            ];
            return res;
          });
          this.initPage(res.data.total);
        } else {
          this.data = [];
        }
      },
      err => {
        this.data = [];
      },
      () => {
        this.is_loading = false;
      }
    );
  }

  submitFilter() {
    this.currentPage = 1;
    const payload = _.assign({}, this.modelFilter);
    payload['is_search'] = true;
    this.loadData(payload).then();
  }

  saveImport() {
    if (this.importType == 'filter') {
      this.campaignService
        .importContactWithFilter(this.campaign_id, {
          filter_id: this.importModel.step1.data,
          target: this.typeFilter,
        })
        .subscribe(
          res => {
            if (res.status == 200 && !res.error) {
              this.importRes = importResponseTemplate(res.data);
            } else {
              this.importRes = 'Import không thành công!';
            }
            this.next(3);
          },
          err => {
            this.importRes = 'Import không thành công!';
            this.next(3);
          }
        );
    } else {
      if (this.importTab === 'import-customer') {
        console.log(this.importModel);
        const payload = {
          group_id: this.importModel.step1.group_id,
          tags: this.importModel.step1.tags
            ? typeof this.importModel.step1.tags === 'string'
              ? this.importModel.step1.tags
              : this.importModel.step1.tags.map(t => t.displayValue).join(',')
            : undefined,
        };
        this.campaignService.importContactWithFile(this.importModel.step1.data, this.campaign_id, payload).then(
          (res: any) => {
            if (res.status == 200 && !res.error) {
              this.importRes = importResponseTemplate(res.data);
            } else {
              this.importRes = 'Import không thành công!';
            }
            this.next(3);
          },
          err => {
            this.importRes = 'Import không thành công!';
            this.next(3);
          }
        );
      } else {
        this.campaignService.importTicket(this.importModel.step1.data, this.campaign_id).then(
          (res: any) => {
            if (res.status == 200 && !res.error) {
              this.importRes = `Import thành công !`;
            } else {
              this.importRes = 'Import không thành công!';
            }
            this.next(3);
          },
          err => {
            this.importRes = 'Import không thành công!';
            this.next(3);
          }
        );
      }
    }
  }

  next(step_id) {
    if (step_id != this.step) {
      if (step_id == 2) {
        if (!this.importModel.step1 || !this.importModel.step1.data) {
          if (this.importType == 'filter') {
            return this.throwError('Vui lòng chọn bộ lọc để import!');
          } else {
            return this.throwError('Vui lòng chọn file để import!');
          }
        }
        this.saveImport();
      }
      this.step = step_id;
    }
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.delete_ids = this.lstChecked;
    return this.campaignService.deleteCampaignContact(this.campaign_id, { contact_ids: this.delete_ids }).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.is_loading = true;
          setTimeout(() => {
            this.loadData();
            this.throwSuccess('Xóa thành công!');
          }, this.default_timeout);
        } else {
          this.throwError(res.message);
        }
      },
      err => {
        this.throwError(err.message);
      }
    );
  }

  openCreateFilterModal() {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.openModal(this.filterTemplate, config);
  }

  changeImportTab(tab) {
    if (tab === 'import-customer') {
      this.typeFilter = 'user';
    } else if (tab === 'import-ticket') {
      this.typeFilter = 'ticket';
    }
    this.importTab = tab;
    this.searchService.listFilter({ type: this.typeFilter }).subscribe(data => {
      this.loadFilters(data, this.typeFilter);
    });
  }

  getFileImportTicketExample() {
    this.campaignService.getFileImportTicketExample();
  }

  getFileImportContactExample() {
    this.contactService.getFileImportContactExample();
  }

  changeChoiceFilter($event) {
    this.importModel['step1'] = {
      type: 'filter',
      data: $event.value,
    };
  }

  changeFilterCity($event) {
    const value = $event.value;
    this.modelFilter.city_id = value && value !== 'chọn' ? value : undefined;
  }

  changeFilterOrganize($event) {
    const value = $event.value;
    this.modelFilter.organize_id = value && value !== 'chọn' ? value : undefined;
  }

  endImport() {
    this.show = 'list';
    this.step = 1;
    this.is_loading = true;
    this.changeImportTab('import-customer');
    setTimeout(async () => {
      await this.loadData();
      this.is_loading = false;
    }, 4500);
  }

  changeFileImportTicket($event) {
    const files = $event.srcElement.files;
    this.importModel.step1.data = files[0];
  }
  changeGroupImport($event) {
    this.importModel.step1.group_id = $event.target.value;
  }

  export() {
    console.log(this.exportFields, 'this.exportFields');
    this.campaignService.exportDetailCampaign(this.campaign_id, this.modelFilter, { fields: this.exportFields });
  }

  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }

  openTicket(ticket_id: any) {
    this.ticketService.find(ticket_id).subscribe(rs => {
      if (rs.status == 200 && rs.error == false) {
        const _ticket = rs.data;
        _ticket._id = ticket_id;
        this.userService
          .find({ _id: _ticket.requester_id })
          .toPromise()
          .then(res => {
            if (res.status == 200 && res.error == false) {
              _ticket.request = res.data;
              this.socketService.opentab(_ticket, 'ticket', 'edit');
            }
          });
      }
    });
  }

  async handleClickFieldContact(key, item) {
    if (key === 'display_ticket') {
      this.openTicket(item.ticket_id);
    } else if (key === 'display_assignee') {
      if (!item.ticket) {
        this.openUser(item);
      } else {
        const user = this.allUser.find(user => user._id === item.ticket.assign_agent_id);
        if (user) {
          this.openUser(user);
        } else {
          this.openUser(item);
        }
      }
    } else {
      this.openUser(item);
    }
  }

  onSaveFilter(data) {
    const payload = {
      data: JSON.stringify(data.data_save),
      main_and_or: data.main_and_or,
      sub_and_or: data.sub_and_or,
      name: data.name,
      type: this.typeFilter === 'user' ? 'user' : 'ticket',
      type_filter: this.typeFilter === 'user' ? 'cus_user' : 'search_ticket',
    };
    if (!payload.name || (payload.name && payload.name.trim() === '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên bộ lọc không được bỏ trống!',
      };
      return;
    }
    this.searchService.createFilter(payload).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.throwSuccess('Thêm mới thành công!');
          this.searchService.listFilter({ type: this.typeFilter }).subscribe(data => {
            this.loadFilters(data, this.typeFilter);
          });
          this.closeModal();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async changedOptionView(data) {
    this.displayColumns = data;
    await this.commonService
      .settingUserConfig({
        user_id: this.user._id,
        contact_campaign_table_columns: JSON.stringify(this.displayColumns),
      })
      .toPromise();
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
  }

  openFilterModal() {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'model-md',
    };
    this.openModal(this.templateFilter, config);
  }

  async onSaveFilterTicket(data) {
    this.saveFilterTicket = data;
  }

  async handleSubmitUpdateGroup(data) {
    const [body, inputParameters]: any = await this.buildPayload(this.saveFilterTicket);
    const payload = {
      data: {
        active_fields: JSON.stringify([...body.active_fields, 'campaign_id']),
        condition: body.condition,
        force_search: 'customer',
        keyword: '',
        label: body.main_and_or,
        sub_label: body.sub_and_or,
        type: 'ticket',
      },
      customer_group_id: data.customer_group_id,
    };
    this.campaignService.updateGroup(inputParameters, payload).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.throwSuccess('Cập nhật thành công!');
        this.closeModal();
      } else {
        this.throwError(res.message);
      }
    });
  }

  async choiceAction(action) {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    switch (action) {
      case 'updateCustomerGroup':
        this.typeModal = 'updateCustomerGroup';
        this.model = {
          customer_group_id: '',
        };
        await this.setUpModel();
        this.openFilterModal();
        break;
      case 'addContact':
        this.importModel = { step1: { type: 'filter' } };
        this.show = 'import';
        break;
      case 'setupCallOut':
        this.model = {
          agent_list: 'all',
          max_call: '1',
        };
        this.typeModal = 'setupCallOut';
        await this.setUpModel();
        this.openModal(this.templateCallOut, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case 'reAssignAgent':
        this.typeModal = 'reAssignAgent';
        this.model = {
          type: 'auto',
          status: '-1',
          from: moment(new Date()).format('YYYY-MM-DD HH:mm'),
          to: moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm'),
        };
        await this.setUpModel();
        this.openModal(this.templateCallOut, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case 'cloneCampaignContact':
        this.typeModal = 'cloneCampaignContact';
        this.model = {
          source_campaign_id: 'auto',
          filter_id: '-1',
        };
        await this.setUpModel();
        this.openModal(this.templateCallOut, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
    }
  }

  async setUpModel() {
    this.modelContent = {
      type: ModalType.Primary,
      submit_title: 'Thực hiện',
    };

    switch (this.typeModal) {
      case 'setupCallOut':
        this.modelContent.title = 'Phân bổ công việc';
        this.modelDisplay = [
          {
            key: 'agent_list',
            label: 'Chuyên viên xử lý',
            type: FormFieldType.Radio,
            value: this.model.agent_list,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
            options: {
              data: [
                { id: 'all', text: 'Toàn bộ chuyên viên' },
                { id: 'agent', text: 'Chỉ định chuyên viên' },
                { id: 'group', text: 'Chuyên viên thuộc bộ phận' },
              ],
            },
          },
        ];
        if (this.model.agent_list === 'agent') {
          this.model.group_ids = [];
          this.modelDisplay = [
            ...this.modelDisplay,
            {
              key: 'agent_ids',
              label: 'Chọn chuyên viên',
              type: FormFieldType.Select2,
              value: this.model.agent_ids,
              required: true,
              disabled: false,
              width: 'full',
              order: 1,
              options: {
                data: this.allAgent,
                select2Options: {
                  placeholder: { id: '', text: 'Chọn chuyên viên' },
                  multiple: true,
                },
              },
            },
          ];
        } else if (this.model.agent_list === 'group') {
          this.model.agent_ids = [];
          this.modelDisplay = [
            ...this.modelDisplay,
            {
              key: 'group_ids',
              label: 'Chọn bộ phận',
              type: FormFieldType.Select2,
              value: this.model.group_ids,
              required: true,
              disabled: false,
              width: 'full',
              order: 2,
              options: {
                data: this.allGroup,
                select2Options: {
                  placeholder: { id: '', text: 'Chọn bộ phận' },
                  multiple: true,
                },
              },
            },
          ];
        } else {
          this.model.agent_ids = [];
          this.model.group_ids = [];
        }
        this.modelDisplay = [
          ...this.modelDisplay,
          {
            key: 'max_call',
            label: 'Số lượng khách hàng tối đa',
            type: FormFieldType.Number,
            value: this.model.max_call,
            required: true,
            disabled: false,
            width: 'full',
            order: 1,
          },
        ];
        break;
      case 'reAssignAgent':
        this.modelContent.title = 'Phân bổ chuyên viên';
        this.modelDisplay = [
          {
            key: 'type',
            label: 'Phân bổ lại chuyên viên xử lý',
            type: FormFieldType.Radio,
            value: this.model.type,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
            options: {
              data: [
                { id: 'auto', text: 'Phân bổ tự động' },
                {
                  id: 'condition',
                  text: 'Chỉ phân bổ các liên hệ thỏa mãn điều kiện',
                },
              ],
            },
          },
        ];
        if (this.model.type === 'condition') {
          this.modelDisplay = [
            ...this.modelDisplay,
            {
              key: 'agent_ids',
              label: 'Các chuyên viên đang được phân bổ',
              type: FormFieldType.Select2,
              value: this.model.agent_ids,
              required: false,
              disabled: false,
              width: 'full',
              order: 1,
              options: {
                data: this.allAgent,
                select2Options: {
                  placeholder: { id: '', text: 'Chọn chuyên viên' },
                  multiple: true,
                },
              },
            },
            {
              key: 'status',
              label: 'Trạng thái công việc',
              type: FormFieldType.Select,
              value: this.model.status,
              required: false,
              disabled: false,
              width: 'full',
              order: 1,
              options: {
                data: this.allStatus,
              },
            },
            {
              key: 'from',
              label: 'Thời gian từ',
              type: FormFieldType.Datepicker,
              value: this.model.from,
              required: false,
              disabled: false,
              width: '1/2',
              order: 1,
              options: {
                format: 'YYYY/MM/DD',
              },
            },
            {
              key: 'to',
              label: 'Thời gian đến',
              type: FormFieldType.Datepicker,
              value: this.model.to,
              required: false,
              disabled: false,
              width: '1/2',
              order: 1,
              options: {
                format: 'YYYY/MM/DD',
              },
            },
          ];
        } else {
          this.model.agent_ids = [];
          this.model.status = null;
        }
        break;

      case 'updateCustomerGroup':
        this.modelContent.title = 'Cập nhật nhóm khách hàng';
        this.modelDisplay = [
          {
            key: 'customer_group_id',
            label: 'Nhóm khách hàng',
            type: FormFieldType.Select2,
            value: this.model.customer_group_id,
            placeholder: 'Chọn nhóm khách hàng',
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
            options: {
              data: this.allGroupEndUser,
            },
          },
        ];
        break;
      case 'cloneCampaignContact':
        this.modelContent.title = 'Sao chép liên hệ';
        this.modelDisplay = [
          {
            key: 'source_campaign_id',
            label: 'Chiến dịch muốn sao chép',
            type: FormFieldType.Select2,
            value: this.model.source_campaign_id,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
            options: {
              data: this.allCampaigns,
              select2Options: {
                placeholder: { id: '', text: 'Chọn chiến dịch' },
              },
            },
          },
          {
            key: 'filter_id',
            label: 'Điều kiện lọc (Theo ticket)',
            type: FormFieldType.Select2,
            value: this.model.filter_id,
            required: false,
            disabled: false,
            width: 'full',
            order: 1,
            options: {
              data: this.listFilterTicket,
              select2Options: {
                placeholder: { id: '', text: 'Chọn bộ lọc' },
              },
            },
          },
        ];
        break;
    }
  }

  async submitCallOut(payload) {
    this.campaignService.assignAgentCampaign(payload).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.closeModal();
          this.throwSuccess('Phân bổ công việc thành công!');
          this.is_loading = true;
          setTimeout(() => {
            this.loadData();
          }, this.default_timeout);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async submitReAssign(payload) {
    this.campaignService.reAssignAgent(payload).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.closeModal();
          this.throwSuccess('Phân bổ công việc thành công!');
          this.is_loading = true;
          setTimeout(() => {
            this.loadData();
          }, this.default_timeout);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }
  async cloneContactCampaign(payload) {
    this.campaignService.cloneContactCampaign(this.campaign_id, payload).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.closeModal();
          this.is_loading = true;
          this.throwSuccess('Sao chép liên hệ thành công!');
          setTimeout(() => {
            this.loadData();
          }, this.default_timeout);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async handleSubmit(item?: any) {
    this.message = null;
    this.model = _.merge({}, this.model, item);
    if (this.typeModal === 'setupCallOut') {
      let agentList = [];
      switch (this.model.agent_list) {
        case 'agent':
          agentList = this.model.agent_ids;
          break;
        case 'group':
          const modelGroup = this.model.group_ids.map(g => Number(g));
          agentList = this.allAgent.filter(agent => modelGroup.includes(Number(agent.group_id))).map(agent => agent.id);
          break;
        default:
          agentList = this.allAgent.map(agent => agent.id);
          break;
      }
      const checkMax = parseFloat(this.model.max_call);
      if (!checkMax || _.isNaN(checkMax) || checkMax < 1) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Số lượng khách hàng tối đa ít nhất là 1!',
        };
      }
      const payload = {
        listUserIds: agentList,
        campaignId: this.campaign_id,
        maxCalls: this.model.max_call,
      };
      await this.submitCallOut(payload);
    } else if (this.typeModal === 'reAssignAgent') {
      let payload = {
        campaign_id: this.campaign_id,
      };
      if (this.model.type !== 'auto') {
        if (this.model.agent_ids && this.model.agent_ids.length > 0) {
          payload['assign_ids'] = this.model.agent_ids;
        }
        if (this.model.status && this.model.status != '-1') {
          payload['status'] = parseFloat(this.model.status);
        }
        const checkDays = moment(new Date()).endOf('day');
        if (this.model.from) {
          if (moment(this.model.from).isAfter(checkDays)) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Thời gian từ không được lớn hơn ngày hiện tại!',
            };
            return;
          }
          payload['from'] = moment(this.model.from).format('YYYY-MM-DD');
        }
        if (this.model.to) {
          if (moment(this.model.to).isAfter(checkDays)) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Thời gian đến không được lớn hơn ngày hiện tại!',
            };
            return;
          }
          payload['to'] = moment(this.model.to).format('YYYY-MM-DD');
        }
        if (this.model.from && this.model.to) {
          if (moment(this.model.from).isAfter(moment(this.model.to))) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Thời gian từ phải nhỏ hơn thời gian đến!',
            };
            return;
          }
        }
      }
      await this.submitReAssign(payload);
    } else {
      const payload = {
        source_campaign_id: this.model.source_campaign_id,
        filter_id: this.model.filter_id && this.model.filter_id != '-1' ? this.model.filter_id : null,
      };
      await this.cloneContactCampaign(payload);
    }
  }

  async onChangeValueModel(key, item?: any) {
    this.message = null;
    this.model = _.merge({}, this.model, item);
    await this.setUpModel();
  }

  async buildPayload(customField = {}) {
    if (!this.campaign_id) {
      return this.throwError('Không tìm thấy chiến dịch');
    }
    let data = this.saveFilterTicket.data_search;
    data['campaign_id'] = [
      {
        match_phrase: {
          campaign_id: this.campaign_id,
        },
      },
    ];
    let active_fields = [...this.saveFilterTicket.active_fields, 'campaign_id'];
    let condition = {};
    const arr = [];
    active_fields = _.union(active_fields);
    active_fields.forEach(field => {
      const sub_condition = {};
      if (this.saveFilterTicket.sub_and_or == 'and') {
        sub_condition['must'] = data[field];
      } else {
        sub_condition['should'] = data[field];
      }
      arr.push({
        bool: sub_condition,
      });
    });
    if (arr.length > 0) {
      if (this.saveFilterTicket.main_and_or == 'and') {
        condition['must'] = arr;
      } else {
        condition['should'] = arr;
      }
    } else {
      condition = {};
    }
    const fill = [];
    let inputParameters = {};
    // console.log("condition:", condition);
    const body = {
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(active_fields),
      type: 'customer',
      label: this.saveFilterTicket.main_and_or,
      sub_label: this.saveFilterTicket.sub_and_or,
      keyword: this.saveFilterTicket.keyword ? this.saveFilterTicket.keyword.trim() : '',
      force_search: 'customer',
      ...customField,
    };
    body['offset'] = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    body['limit'] = this.page_size;
    // update filter
    const params = {
      filter: '',
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      limit: this.page_size,
      sort_by: 'updated_at:desc',
      source: 'all',
    };
    if (this.saveFilterTicket.keyword) {
      fill.push({
        key: 'subject',
        condition: '=',
        value: this.saveFilterTicket.keyword ? this.saveFilterTicket.keyword.trim() : '',
      });
    }
    params.filter = JSON.stringify(fill);
    inputParameters = params;
    return [body, inputParameters];
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/detail/contacts/contacts.component.ts